import './esport.css';

const Esport = () => {
    return (
        <a href='/esport'>
            <div className="column esport">
                <h2 className="title">ESPORT</h2>
            </div>
        </a>
    );
}

export default Esport;